module.exports = __webpack_public_path__ + "img/00012.e511d4b1.webp";